import { Icon } from '@cbhq/cds-web/icons/Icon';
import { Box, HStack } from '@cbhq/cds-web/layout';
import { Table, TableBody, TableCell, TableHeader, TableRow } from '@cbhq/cds-web/tables';
import { Link, TextBody, TextHeadline } from '@cbhq/cds-web/typography';

import { getFormattedId } from ':cloud/utils/common';
import { ClipboardIcon } from ':cloud/widgets/sharedcomponents';
import networkData from ':cloud/widgets/staking/networkData';

function NetworkTable() {
  return (
    <Box spacing={3} spacingBottom={10}>
      <Table>
        <TableHeader>
          <TableRow>
            <TableCell>Network</TableCell>
            <TableCell>API</TableCell>
            <TableCell>Community delegation</TableCell>
            <TableCell>Custom validators</TableCell>
            <TableCell>Est. APY</TableCell>
            <TableCell>Delegation minimum</TableCell>
            <TableCell width={120}>Est. reward frequency</TableCell>
            <TableCell width={120}>Unbonding period</TableCell>
            <TableCell width={130}>Community validator commission</TableCell>
            <TableCell>Community validator address</TableCell>
            <TableCell>Guides</TableCell>
          </TableRow>
        </TableHeader>
        <TableBody>
          {networkData.map((network) => {
            const { Logo } = network;
            return (
              <TableRow key={network.asset}>
                <TableCell alignItems="flex-start">
                  {typeof network.network === 'string' ? (
                    <HStack alignItems="center" gap={1}>
                      <Logo height={24} width={24} />
                      <TextHeadline as="p">{network.network}</TextHeadline>
                    </HStack>
                  ) : (
                    network.network
                  )}
                </TableCell>
                <TableCell alignItems="center">
                  <Icon
                    size="m"
                    color={network.hasApi ? 'positive' : 'foregroundMuted'}
                    name={network.hasApi ? 'circleCheckmark' : 'circleCross'}
                  />
                </TableCell>
                <TableCell alignItems="center">
                  {typeof network.hasCommunityValidators === 'boolean' ? (
                    <Icon
                      size="m"
                      color={network.hasCommunityValidators ? 'positive' : 'foregroundMuted'}
                      name={network.hasCommunityValidators ? 'circleCheckmark' : 'circleCross'}
                    />
                  ) : (
                    network.hasCommunityValidators
                  )}
                </TableCell>
                <TableCell alignItems="center">
                  <Icon
                    size="m"
                    color={network.hasDedicatedValidators ? 'positive' : 'foregroundMuted'}
                    name={network.hasDedicatedValidators ? 'circleCheckmark' : 'circleCross'}
                  />
                </TableCell>
                <TableCell alignItems="center">
                  <TextHeadline align="end" as="p">
                    {network.estimatedRewards}
                  </TextHeadline>
                </TableCell>
                <TableCell alignItems="center">
                  <TextBody align="end" as="p" color="foregroundMuted">
                    {network.delegationMinimum}
                  </TextBody>
                </TableCell>
                <TableCell alignItems="center">
                  <TextBody align="end" as="p" color="foregroundMuted">
                    {network.payoutPeriod}
                  </TextBody>
                </TableCell>
                <TableCell alignItems="center">
                  <TextBody align="end" as="p" color="foregroundMuted">
                    {network.unbondingPeriod}
                  </TextBody>
                </TableCell>
                <TableCell alignItems="center">
                  <TextBody align="end" as="p" color="foregroundMuted">
                    {/* if commision ends in '%' do not include decimals */}
                    {network.commission.endsWith('%')
                      ? `${(+network.commission.slice(0, -1)).toFixed(0)}%`
                      : network.commission}
                  </TextBody>
                </TableCell>
                <TableCell alignItems="center">
                  {typeof network.communityValidatorAddress === 'string' ? (
                    <HStack alignItems="center" background="primaryWash" gap={1}>
                      <TextBody align="end" as="p" color="foregroundMuted">
                        {getFormattedId(network.communityValidatorAddress, 3)}
                      </TextBody>
                      <ClipboardIcon
                        text={network.communityValidatorAddress}
                        iconSize="s"
                        stopPropagation
                      />
                    </HStack>
                  ) : (
                    network.communityValidatorAddress
                  )}
                </TableCell>
                <TableCell alignItems="center">
                  {network.guide ? (
                    <TextBody as="p">
                      <Link href={network.guide} openInNewWindow>
                        Learn
                      </Link>
                    </TextBody>
                  ) : (
                    <TextBody color="foregroundMuted" as="p">
                      -
                    </TextBody>
                  )}
                </TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </Box>
  );
}

export default NetworkTable;
